module.exports = __webpack_public_path__ + "static/media/divider-access-restricted.204c8ad1.png";